import { ROUTE_NAMES } from '@/constant/routes'

// AHA-47221: where a PowerPoint add-in frame goes when it has no presentation to show.
//
// One function rather than the branch written out at each call site, because there are two of
// them and they race: PptAddinLanding's fallback timer and services/office's cold-load settle
// both aim a frame at "the presentation list", and if they ever disagreed about which list
// that is, a frame rescued by one would be yanked to the other's route by the next.
//
// Flag ON  => the embed list route. Same list component as the dashboard page, without the
//             sidebar/workspace shell around it; EmbeddableMyPresentations supplies the
//             add-in's click behaviour there.
// Flag OFF => ROUTE_NAMES.PRESENTATIONS — the original destination, unchanged.
//
// The store is a PARAMETER, not an `import store from '@/vuex/store'` the way
// ppt-slide-selector-gate.js does it. PptAddinLanding is one of the callers and is
// deliberately import-light — it is the route a frame parks on before anything is loaded —
// and pulling the real store (and the router it syncs with) in behind it defeats that and
// breaks its unit test's mocked $route. A storeless caller reads as flag-off, which
// is the safe answer: the original destination.
export const pptAddinListRouteName = (store) => {
  if (store?.getters?.['featureToggles/canUsePptNewUi']) {
    return ROUTE_NAMES.EMBED_MY_PRESENTATIONS
  }
  return ROUTE_NAMES.PRESENTATIONS
}

export default pptAddinListRouteName
